/**
 * Ridhivam Product Page Redesign JavaScript Handlers
 */

document.addEventListener("DOMContentLoaded", function () {
  // 1. Intersection Observer for pausing/playing vertical videos in the viewport
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, {
    root: null,
    threshold: 0.25 // Trigger play when at least 25% of the video card is visible
  });

  document.querySelectorAll('.image-video-gallery-item video').forEach(video => {
    videoObserver.observe(video);
  });

  // 2. High-performance Intersection Observer for the Sticky Add-to-Cart bar
  const mainCta = document.querySelector('.product-form__buttons');
  const stickyCart = document.querySelector('.stickyCart');

  if (mainCta && stickyCart) {
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          // If scroll is past the main CTA (going down)
          if (window.scrollY > entry.boundingClientRect.top + window.scrollY) {
            stickyCart.classList.add('stickyCart-active');
          } else {
            stickyCart.classList.remove('stickyCart-active');
          }
        } else {
          stickyCart.classList.remove('stickyCart-active');
        }
      });
    }, {
      root: null,
      threshold: 0
    });

    stickyObserver.observe(mainCta);
  }

  // 3. Click handler for the Sticky Buy Now button
  const stickyBuyNow = document.getElementById('sticky-buy-now');
  if (stickyBuyNow) {
    stickyBuyNow.addEventListener('click', function () {
      // Find the main dynamic checkout button on the page
      const mainBuyNow = document.querySelector('.shopify-payment-button__button');
      if (mainBuyNow) {
        mainBuyNow.click();
      } else {
        // Fallback: Submit the main product form directly to checkout
        const mainForm = document.querySelector('product-form form');
        if (mainForm) {
          let checkoutInput = mainForm.querySelector('input[name="return_to"]');
          if (!checkoutInput) {
            checkoutInput = document.createElement('input');
            checkoutInput.type = 'hidden';
            checkoutInput.name = 'return_to';
            checkoutInput.value = '/checkout';
            mainForm.appendChild(checkoutInput);
          }
          mainForm.submit();
        }
      }
    });
  }
});
